import { render, staticRenderFns } from "./cate-update.vue?vue&type=template&id=498f235c"
import script from "./cate-update.vue?vue&type=script&lang=js"
export * from "./cate-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports